/**
 * Story note controller
 * @author Brendan Magee
 */

function StoryNoteController($scope, $log, $translate, storiesService) {
  $scope.alerts = [];

  $scope.toggleForm = () => {
    $scope.showForm = !$scope.showForm;
    $scope.noteToEdit = angular.copy($scope.story.note);
  };

  $scope.updateNote = () => {
    $scope.alerts = [];

    const payload = {
      id: $scope.story.id,
      note: $scope.noteToEdit
    };

    storiesService.updateStory(payload).then(() => {
      $scope.story.note = $scope.noteToEdit;
      $scope.showForm = false;
    }, (response) => {
      $log.error('storyNote.controller storiesService.updateStory() error', response.data.error || response);
      $scope.alerts.push({ text: $translate.instant('ERROR_UPDATING_STORY_NOTE') });
    });
  };
}

const controllerArray = [
  '$scope',
  '$log',
  '$translate',
  'storiesService',
  StoryNoteController
];

export default function (ngModule) {
  ngModule.controller('StoryNoteController', controllerArray);
}
